// extracted by mini-css-extract-plugin
var _1 = "QMN2jPSSXnC1dd6oxqa0";
var _2 = "QMN2jPSSXnC1dd6oxqa0";
var _3 = "AXorfYR6cvHaSnmkWr3N";
var _4 = "N9uZuX9c8kmH0SEGKtAu";
var _5 = "AXorfYR6cvHaSnmkWr3N";
var _6 = "N9uZuX9c8kmH0SEGKtAu";
var _7 = "fE9WGtqI48kVtSg8l5nA";
var _8 = "fE9WGtqI48kVtSg8l5nA";
var _9 = "_tddDmdPVG0flbTiG2iA";
var _a = "_qF23ijLakXhOyb7Nh03";
var _b = "_qF23ijLakXhOyb7Nh03";
var _c = "Coy2U6lAJI7Pcm6mnbXr";
export { _1 as "approval-message", _2 as "approvalMessage", _3 as "close-anchor", _4 as "close-button-div", _5 as "closeAnchor", _6 as "closeButtonDiv", _7 as "inline-block", _8 as "inlineBlock", _9 as "modal", _a as "terms-and-conditions", _b as "termsAndConditions", _c as "title" }
